const EndCallIcon = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
        <path d="M40 20C40 31 31 40 20 40 9 40 0 31 0 20 0 9 9 0 20 0 31 0 40 9 40 20Z" fill="#db3545" />
        <path d="M30.2 22.3C30.7 21.2 30.1 19.4 29.4 18.4 27.2 15.3 22.8 14.9 19.3 15.2 16.2 15.5 10.6 16.4 10.6 20.5 10.6 21.1 10.7 21.7 11.1 22.1 11.8 22.8 12.8 22.7 13.7 22.6 14.3 22.5 15.8 22.5 16.3 22.1 16.7 21.6 16.5 20.9 16.6 20.4 16.6 20.3 16.6 19.6 16.6 19.5 16.6 19.3 18.3 19 18.5 19 19.1 18.9 19.8 18.8 20.5 18.8 21.2 18.8 21.8 18.9 22.5 19 23.1 19.1 23.7 19.3 24.3 19.6 24.3 19.6 24.3 20.7 24.3 21.1 24.5 21.9 24.6 22.6 25.6 22.8 25.9 22.9 26.3 23 26.6 23 27.3 23 27.9 23 28.6 22.9 29 22.9 29.5 22.8 29.9 22.6 30 22.5 30.1 22.4 30.2 22.3Z" fill="#fff" />
      </svg>
    );
  }
  
  export default EndCallIcon;